import API from "./api";

// 🔥 GET ALL ORDERS
export const getOrders = () => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.get("/school-admin/orders/", {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};

// 🔥 UPDATE ORDER STATUS
export const updateOrder = (id, data) => {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  return API.post(`/school-admin/orders/update/${id}/`, data, {
    headers: {
      "X-SCHOOL-ID": school.school.id,
    },
  });
};